import { View } from 'react-native';
import { Image } from 'expo-image';
import { useSelector } from 'react-redux';

import tw from '../../styles/tailwind';
import useActiveAdminCommunity from '@/hooks/useActiveAdminCommunity';
import Text from '@/components/Text';


export default function AdminTopBar() {
  const {community} = useActiveAdminCommunity();
  const state = useSelector(state => state.status)


  return (
    <View style={tw`h-18 row justify-between bg-white border-b-2 border-gray-300 px-6`}>
      <View style={tw`row`}>
        <View style={tw`rounded-xl border-secondary border w-13 h-13 bg-white overflow-hidden mr-4`}>
          <Image style={tw`w-full h-full`} source={community.image_path} />
        </View>

        <View>
          <Text style={tw`text-lg font-500 text-gray-700`}>Bienvenido</Text>
          <Text style={tw`text-secondary text-gray-700 -mt-1`}>{community.name}</Text>
        </View>
      </View>

      <View style={tw``}>
        <Text style={tw`text-base text-right`}>{state.user?.name}</Text >

        <Text style={tw`text-gray-700 -mt-1 text-right`}>{state.user?.email}</Text>
      </View>
    </View>
  );
}
